import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";

const useStyles = createUseStyles((_) => ({
  container: {
    width: "100%",
    minHeight: "var(--app-height)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "32px 20px",
    paddingTop: "max(32px, env(safe-area-inset-top))",
    paddingBottom: "max(32px, env(safe-area-inset-bottom))",
    backgroundColor: colors.secondary,
  },

  logo: {
    width: "min(226px, 70%)",
    height: "auto",
    maxHeight: "130px",
    objectFit: "contain",
  },

  divText: {
    display: "flex",
    flexDirection: "column",
    gap: "34px",
    textAlign: "center",
    maxWidth: "420px",
    [down.sm]: {
      gap: "20px",
    },
  },

  subContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    width: "100%",
    maxWidth: "350px",
    marginTop: "36px",
    [down.sm]: {
      marginTop: "24px",
    },
  },
  customLabel: {
    margin: "9px 16px",
    "& .MuiTypography-root": {
      color: colors.WHITE,
      fontFamily: "Poppins-Regular",
      fontSize: 13,
    },
  },
  customCheckbox: {
    "& .MuiSvgIcon-root": {
      fontSize: 13,
      color: colors.WHITE,
    },
  },
  forgotPassword: {
    textAlign: "center",
  },
}));

export default useStyles;
